export const optVal = (o) => (o && typeof o === "object" ? o.value ?? o.label : o);
export const optLabel = (o) => (o && typeof o === "object" ? o.label ?? o.value : o);
export const SELECT_TYPES = ["select", "multiselect", "multi_select", "dropdown", "status"];
export const LONG_TYPES = ["textarea", "long_text", "longtext", "richtext", "json"];

export const fmtVal = (v) => {
  if (v === null || v === undefined || v === "") return "";
  if (Array.isArray(v)) return v.map(fmtVal).join(", ");
  if (typeof v === "object") return JSON.stringify(v);
  if (typeof v === "boolean") return v ? "Yes" : "No";
  return String(v);
};

export function recordTitle(r, fields, titleField) {
  const d = r.data || {};
  if (titleField && d[titleField]) return fmtVal(d[titleField]);
  for (const k of ["name", "title", "label", "headline", "campaign_name", "ad_name"]) if (d[k]) return fmtVal(d[k]);
  const f = fields.find((x) => !SELECT_TYPES.includes(x.type) && !LONG_TYPES.includes(x.type) && d[x.key]);
  return f ? fmtVal(d[f.key]) : r._id;
}

export function buildParams({ q, filters, sort, dir, limit, skip }) {
  const p = new URLSearchParams();
  if (q) p.set("q", q);
  Object.entries(filters || {}).forEach(([k, v]) => { if (v !== "" && v != null) p.append(k, v); });
  if (sort) p.set("sort", sort);
  if (dir) p.set("dir", dir);
  p.set("limit", String(limit ?? 50));
  p.set("skip", String(skip ?? 0));
  return p;
}

export function toCsv(rows, fields) {
  const cols = [...fields.map((f) => f.key), "created_at", "updated_at", "created_by"];
  const esc = (s) => `"${String(s ?? "").replace(/"/g, '""')}"`;
  const head = [...fields.map((f) => f.label || f.key), "Created at", "Updated at", "Created by"].map(esc).join(",");
  const body = rows.map((r) => cols.map((c) => esc(fmtVal(c in (r.data || {}) ? r.data[c] : r[c]))).join(","));
  return [head, ...body].join("\n");
}
